export default "__VITE_ASSET__Da4f74GB__"